// usePortfolioTickers — returns a deduped ticker[] from the signed-in
// user's active portfolio uploads. Powers the Portfolio tab on the hero
// chart. Returns `{ tickers, loading, signedIn }`:
//   - signedIn=false → no user, no fetch attempted, tickers=[]
//   - signedIn=true,  loading=true  → request in flight
//   - signedIn=true,  loading=false → tickers is the final list (may be [])

import { useEffect, useState } from 'react'
import { useAuth, useUser } from '@clerk/clerk-react'

export function usePortfolioTickers() {
  const { user, isLoaded } = useUser()
  const { getToken } = useAuth()
  const [tickers, setTickers] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!isLoaded) return
    if (!user?.id) {
      setTickers([])
      setLoading(false)
      setError(null)
      return
    }
    let cancelled = false
    setLoading(true)
    setError(null)
    ;(async () => {
      try {
        const token = await getToken()
        if (cancelled) return
        const r = await fetch('/api/portfolio?action=read', {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        })
        if (cancelled) return
        if (!r.ok) {
          setTickers([]); setLoading(false); setError(new Error(`portfolio HTTP ${r.status}`)); return
        }
        const j = await r.json().catch(() => ({}))
        if (cancelled) return
        const seen = new Set()
        const out = []
        for (const u of (j.uploads || [])) {
          for (const h of (u.holdings || [])) {
            const t = String(h.ticker || '').toUpperCase()
            if (t && !seen.has(t)) { seen.add(t); out.push(t) }
          }
        }
        setTickers(out)
        setLoading(false)
      } catch (e) {
        if (!cancelled) { setTickers([]); setLoading(false); setError(e) }
      }
    })()
    return () => { cancelled = true }
    // getToken is stable per Clerk session
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, user?.id])

  return { tickers, loading, error, signedIn: !!user?.id }
}
